module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Layout/Layout-top-panel-2-a1f549c3d1c9d8f1b04336087029951d.svg";